export default __webpack_public_path__ + "static/media/tt.740c30e3.svg";